import { useEffect, useState } from 'react';
import LostReasonService from '../LostReason/services/LostReasonService';
import { toast } from 'react-toastify';

export function useGetLostReasonByEntity({ entity, recordTypeId }) {
  const [listLostReason, setListLostReason] = useState([]);

  useEffect(() => {
    LostReasonService.getByEntity(entity)
      .then((response) => {
        const data = response.data.data.data;
        const filteredData = data.filter(
          (dataItem) =>
            dataItem.isActive === true &&
            dataItem.recordTypesConfig.some(
              (recordType) => recordType.recordTypeId === Number(recordTypeId)
            )
        );

        setListLostReason(filteredData);
      })
      .catch((error) => {
        const message =
          error.response?.data?.message || 'Erro ao carregar os dados';

        toast.error(message, {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  }, []);

  return { listLostReason };
}
